import React from 'react';
import { Oval } from 'react-loader-spinner';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingSpinner = ({
  width = null,
  height = null,
  background = 'transparent'
}) => {
  return /*#__PURE__*/_jsx(SpinnerSection, {
    className: "flex items-center justify-center",
    $width: width,
    $height: height,
    $background: background,
    children: /*#__PURE__*/_jsx(Oval, {
      height: 50,
      width: 50,
      color: "var(--blue-50)",
      secondaryColor: "var(--gray-80)",
      visible: true,
      ariaLabel: "oval-loading",
      strokeWidth: 4,
      strokeWidthSecondary: 4
    })
  });
};
const SpinnerSection = styled.section.withConfig({
  componentId: "sc-kgvh0o-0"
})(["width:", ";min-height:", ";height:", ";max-height:100vh;background:", ";opacity:0.5;"], props => props.$width ? props.$width : '100%', props => props.$height ? '' : 'calc(100vh - var(--height-global-nav))', props => props.$height ? props.$height : '100%', props => props.$background);
export default LoadingSpinner;